import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  httpOptions;
  httpBoday = '';
  tokenData;
  countrieValue;
  buid;
  buisnessUnitId;
  buisnessUnitIdForSetting_Depatment;
  buisnessUnitIdToFetchDepatment;
  pageIndex = 1;
  pageSize = 10;
  paginationValue = 1;

  constructor(private http: HttpClient) { }

  getValueOfPagination(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
  }

  getIndustry(): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.BusinessUnits.industries, this.httpOptions);
  }

  getDepartmentData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    try {
      return this.http.get<any>(ApiEndPoint.BusinessUnits.departments, this.httpOptions);
    } catch (error) {
      console.log(error);
    }
  }

  getBusinessUnitData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.BusinessUnits.businessUnits, this.httpOptions);
  }

  getValueForPaginationBusinessUnit(value) {
    this.paginationValue = value;
  }

  addBuisnessUnit(BUBoday): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json',
        // Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.BusinessUnits.businessUnits, BUBoday, this.httpOptions);
  }

  updateBuisnessUnit(BUBoday): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.BusinessUnits.businessUnits, BUBoday, this.httpOptions);
  }

  deleteBuisnessUnit(BUID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.BusinessUnits.businessUnits + `/delete`, { "buid": BUID }, this.httpOptions);
  }

  getBuisnessUnitOnAccorrdionOpen(buisnessUnitIdForSetting_Depatment) {
    this.buisnessUnitIdForSetting_Depatment = buisnessUnitIdForSetting_Depatment;
  }

  getDepartmentForSetting_Department() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };
    // tslint:disable-next-line: max-line-length
    return this.http.get<any>(
      ApiEndPoint.BusinessUnits.businessUnits +
      `/${this.buisnessUnitIdForSetting_Depatment}/departments?recordsPerPage=${this.pageSize}&page=${this.pageIndex}`,
      this.httpOptions
    );
  }

  getDepartmentForSettingOfBU(buId) {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };
    // tslint:disable-next-line: max-line-length
    return this.http.get<any>(ApiEndPoint.BusinessUnits.businessUnits + `/${buId}/departments?recordsPerPage=100&page=1`, this.httpOptions);
  }

  addDepartmentDataFor_Setting(department, buid): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.BusinessUnits.businessUnits + `/${buid}/departments`, 
        department, 
        this.httpOptions);
  }

  updateDepartmentDataFor_Setting(department, deptId, buid): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.BusinessUnits.businessUnits + `/${buid}/departments/${deptId}`,
      department, 
      this.httpOptions);
  }

  deleteDepartment(buID, deptID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.BusinessUnits.businessUnits + `/${buID}/departments/${deptID}/delete`, '', this.httpOptions);
  }

  getBuidFromDepartment(value) {
    this.buid = value;
  }

  getDepartment(buisnessUnitId) {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.BusinessUnits.businessUnits + `/${buisnessUnitId}/departments`,
      this.httpOptions
    );
  }

  getBuisnessUnitIdForFetchDepartment(id) {
    this.buisnessUnitIdToFetchDepatment = id;
  }

  getDepartmentDataForPowerUser() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.BusinessUnits.businessUnits + `/${this.buisnessUnitIdToFetchDepatment}`,
      this.httpOptions
    );
  }
  
  isExist(request): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce 
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.BusinessUnits.departments + '/exist', 
            request,
            httpOptions);
        })
      );
  }

  isBusinessUnitExist(request): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.BusinessUnits.businessUnits + '/exist', 
                                    request,
                                    httpOptions); 
        })
      );
  }
}
